import { Pipe, PipeTransform} from '@angular/core';
import { ISimpleListItem } from '../interfaces/ISimpleListItem';

@Pipe({
    name: 'isStoreMainOrBbm',
    standalone: false
})
export class IsStoreMainOrBbmPipe implements PipeTransform {

  public transform(store: ISimpleListItem, onlyBbm = false, onlyMain = false): boolean {
    if (!onlyBbm && !onlyMain) {
      return store.additionalParameters['isMainStore'] === 'True' ||
        store.additionalParameters['isBbmStore'] === 'True';
    } else if (onlyBbm) {
      return store.additionalParameters['isBbmStore'] === 'True';
    } else if (onlyMain) {
      return store.additionalParameters['isMainStore'] === 'True';
    }
  }
}
